export default __webpack_public_path__ + "static/media/main_slide_m.ece20b07.png";